import React, { useState } from 'react';
import { BsPaintBucket } from 'react-icons/bs';
import { colorSelectedToStyle, colorStyles } from './PropsAvatar';

export const ColorPaletteBackground = ({ colorStyleID, avatarColorProps, setAvatarColorProps }) => {
    const [clicked, setClicked] = useState(false);

    function handleChange(color) {
        const key = colorSelectedToStyle[colorStyleID];
        const newProps = { ...avatarColorProps };
        newProps[key] = color;
        setAvatarColorProps(newProps);
        setClicked(!clicked);
    }

    return (
        <>
            {
                clicked
                    ? <div className='grid gap-1 items-center relative h-2 w-2 mx-4 my-2'>
                        {colorStyles[5].map(
                            (item, elem) => {
                                return (
                                    <div className='relative w-6 h-6 xs:w-5 xs:h-5 rounded-50 border-black border-solid border-2' key={elem} id={item}
                                        style={{
                                            backgroundColor: item,
                                        }}
                                        onClick={(e) => { handleChange(e.target.id); }}>
                                    </div>
                                );
                            },
                        )}
                    </div>
                    : <BsPaintBucket onClick={setClicked(!clicked)} className='w-8 h-8 m-2 outline rounded-50'></BsPaintBucket>
            }
        </>
    );
};
